import { generatePath } from "react-router";
import { RoutesPath } from "flow-components/routes/routes";
import { BrokerModel, ProfileModel } from "dash-common";

type Portfolio = {
  _id: string;
  isParentRoot: boolean;
  portfolioFolder?: {
    name?: string | null;
  } | null;
  portfolioFolderId?: string | null;
  brokerId: string;
  name?: string | null;
  property?: {
    _id: string;
  } | null;
};

/** generatePath do not paras params after * 
 while this is special character for react router,
 so we need to replace to url special character before call generatePath **/
const fixGeneratePathParam = (str?: string | null) =>
  (str || "").replaceAll("*", "%2A");

const getPreviewPortfolioPropertyPath = (
  portfolio: Portfolio,
  broker?: BrokerModel | null,
  profile?: ProfileModel | null
) =>
  encodeURI(
    generatePath(
      !portfolio.isParentRoot
        ? RoutesPath.PropertyInPortfolioPreview
        : RoutesPath.PortfolioPropertyPreview,
      {
        brokerId: fixGeneratePathParam(broker?._id),
        brokerName: fixGeneratePathParam(
          profile?.lastName
            ? `${profile?.firstName}-${profile?.lastName}`
            : profile?.firstName || "agent"
        ),
        portfolioName: fixGeneratePathParam(portfolio.name),
        portfolioFolderName: fixGeneratePathParam(
          portfolio.portfolioFolder?.name
        ),
      }
    ).replaceAll("%2A", "*")
  );

const getPreviewPortfolioPath = (
  portfolio: Portfolio,
  broker?: BrokerModel | null,
  profile?: ProfileModel | null
) =>
  encodeURI(
    generatePath(RoutesPath.PortfolioPreview, {
      brokerId: fixGeneratePathParam(broker?._id),
      brokerName: fixGeneratePathParam(
        profile?.lastName
          ? `${profile?.firstName}-${profile?.lastName}`
          : profile?.firstName || "agent"
      ),
      portfolioFolderName: fixGeneratePathParam(portfolio.name),
    }).replaceAll("%2A", "*")
  );

const getPreviewPortfolioPropertyLink = (
  portfolio: Portfolio,
  broker?: BrokerModel | null,
  profile?: ProfileModel | null
) =>
  `${window.location.origin}${getPreviewPortfolioPropertyPath(
    portfolio,
    broker,
    profile
  )}`;

const getPreviewPortfolioLink = (
  portfolio: Portfolio,
  broker?: BrokerModel | null,
  profile?: ProfileModel | null
) =>
  `${window.location.origin}${getPreviewPortfolioPath(
    portfolio,
    broker,
    profile
  )}`;

const getSharePropertyLink = (
  property: {
    _id: string;
    name?: string | null;
  },
  broker?: BrokerModel | null,
  profile?: ProfileModel | null
) =>
  `${window.location.origin}${encodeURI(
    generatePath(RoutesPath.ShareProperty, {
      brokerId: fixGeneratePathParam(broker?._id),
      brokerName: fixGeneratePathParam(
        profile?.lastName
          ? `${profile?.firstName}-${profile?.lastName}`
          : profile?.firstName || "agent"
      ),
      propertyId: fixGeneratePathParam(property._id),
      propertyName: fixGeneratePathParam(property.name),
    }).replaceAll("%2A", "*")
  )}`;

export { getPreviewPortfolioPropertyLink, getPreviewPortfolioLink, getSharePropertyLink };
